import { gardening, medicalChatbot, mentalVerse, Asset } from '../assets';

const TechnologyTag = ({ technologies }) => {
    return (
        <div className="technology-container">
            {technologies.map((technology, index) => (
                <p key={index} className="technology">{technology}</p>
            ))}
        </div>
    );
}

interface ProjectProps {
    name: string;
    technologies: string[];
    description: string[];
    image?: Asset;
    video?: string;
    link?: string;
}

const Project = ({ name, technologies, description, image, video, link }: ProjectProps) => {
    return (
        <div className="project">
            <div className="project__text">
                <h2>{name}</h2>

                <TechnologyTag technologies={technologies} />

                {description.map((paragraph, index) => (
                    <p key={index} dangerouslySetInnerHTML={{ __html: paragraph }} />
                ))}

                {link &&
                    <h4>Check the project on:
                        <a href={link} target="_blank" rel="noopener noreferrer">{link.slice(8)}</a>
                    </h4>}

            </div>

            {video && <div className="project__video">
                <iframe
                    src={video}
                    title={name + " demo"}
                    allow="accelerometer; clipboard-write; autoplay; encrypted-media; gyroscope; picture-in-picture, web-share"
                    allowFullScreen>
                </iframe>
            </div>}
            { image && <div className="project__image">
                <img src={image.src} alt={image.alt} />
            </div>}
        </div>
    );

}
const Projects = () => {
    return <section id="projects">
        <h1 className="underline-title">Projects</h1>
        <Project
            name="Apartment Explorer"
            technologies={['C#', 'Unity', 'AR Core', 'Blender']}
            description={['<strong>Apartment Explorer</strong>, my bachelor\'s degree project, is an <strong>AR (Augmented Reality) </strong> android application that lets the user scan their room, make a furniture selection and visualise it into an optimally designed arrangement, in real life, by using the smartphone’s camera.',
                'The app implements interior design constraints defined through mathematical functions, heuristics, and optimization techniques like <strong>Backtracking</strong> and <strong>Simulated Annealing</strong> algorithms, integrated with the <strong>AR system</strong> and self made <strong>3D models</strong> to offer the most suitable furniture layout.',
                // 'I am working on an article about this project and intending to present it to KES International Conference 2024.'
                ]}
            video="https://www.youtube.com/embed/-DcxdbloY9I?si=HoSUCt109FeVHgL3"
        />
        <Project
            name="MentalVeRse"
            technologies={['.NET', 'Angular', 'Google Cloud Platform', 'Bootstrap', 'HTML', 'Docker']}
            description={['<strong>MentalVeRse</strong> is a single page web application that introduces a platform offering free gamified VR therapy for various phobias through exposure techniques.',
                'The server queries Google Cloud Functions to fetch varied data for the page. The app is deployed on Cloud Run using Docker.',
            ]}
            image={mentalVerse}
            link="https://mentalverse.app"
        />
        <Project
            name="Visual Impairments Extension"
            technologies={['Typescript', 'ReactJS', 'CSS', 'Chrome Extension API', 'Vite']}
            description={['<strong>Visual Impairments Extension</strong> is a chrome extension designed to enhance accessibility for users with visual impairments and neurological conditions.',
                'This tool currently offers presets for <strong>myopia</strong>, <strong>color blindness</strong>, and <strong>dyslexia</strong>, while also allowing users to create their own profiles with customizable settings to further personalize their browsing experience.',
                // 'We are actively developing a user survey system integrated with AI analysis, in order to improve and customize profiles.'
            ]}
            video="https://www.youtube.com/embed/FG0ETQ6bwyE?si=Vczw-W5x1ft-R-ad"
        />
        <Project
            name="Quizz App - Java and DBMS Project"
            technologies={['Java Spring', 'PLSQL', 'Oracle', 'JavaScript', 'HTML/CSS', 'Jgrapht', 'Graphviz']}
            description={['<strong>QuizzApp</strong> is a dynamic web application built using Java. The app generates random quizzes with various topics. ',
                'It uses PLSQL commands for table creation and procedures for quiz generation, scoring, retrieving answers, and displaying top scores.',
                'QuizzApp allows account creation with email validation and provides a statistic page with the score table, the bipartite graph, in which connections are made between users who have at least 5 topics in common.']}
            link="https://github.com/PopaBiancaStefana/QuizzApp"
        />
        <Project
            name="Medical Chatbot - AI Project"
            technologies={['Python', 'PyTorch', 'Tkinter']}
            description={['<strong>Medical Chatbot</strong> is a Python application developed by a two-student team, aiming to provide a simple chat interface for inquiring about COVID-19, flu and cold.',
                'The chatbot utilizes Artificial Intelligence through a three-layer neural network, trained on a self-made dataset and featuring ReLU activations and CrossEntropyLoss for efficient pattern recognition and classification.',
                'The training data is processed for tokenization, stemming, and removal of punctuation from sentences, conversion to a bag-of-words format and creation of training pairs with associated tags.']}
            image={medicalChatbot}
            link="https://github.com/PopaBiancaStefana/Medical-Chatbot"
        />
        <Project
            name="Gardening Tutor - WebDev Project"
            technologies={['JavaScript', 'MySQL', 'HTML/CSS', 'EJS']}
            description={['<strong>Gardening Tutor</strong> is a web application created by a team of 3 students, providing a range of gardening courses.',
                'The platform follows the MVC model and includes features like progress tracking, achievements, and a gardening planning tool for monitoring of plant evolution throughout their growth.',]}
            image={gardening}
            link="https://github.com/PopaBiancaStefana/Web-Gardening-Tutor"
        />
    </section>;
};

export default Projects;